import React from "react";
import t1 from "../../assets/Images/boikee.png";

const TravLadhak = () => {
  return (
    <div
      className="mb-0"
      style={{
        backgroundImage: `url(${t1})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        height: "400px", // adjust as needed
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="container text-center">
        <p className="h4 fw-bold" style={{ color: "#ff9900" }}>
          IT'S ALL ABOUT THE JOURNEY
        </p>
      </div>
    </div>
  );
};

export default TravLadhak;
